module.exports = __webpack_public_path__ + "img/photo2.e6a4cc39.png";